module.exports = __webpack_public_path__ + "img/competition.31056cb0.svg";